module.exports = __webpack_public_path__ + "static/media/value_prop_img_3.1ed78efc.jpg";


//////////////////
// WEBPACK FOOTER
// ./packages/smart-home-support/assets/resources/SHS-WEB/value_prop_img_3.jpg
// module id = 1433
// module chunks = 0